export const ANALYTICS_FEATURES = {
  HERO_ARTICLE: 'Hero',
  HIGHLIGHTS: 'Highlights',
  POPULAR: 'Popular',
  PROJECT_REVIEW: 'Latest Project Review',
  EDITORS_PICK: 'Editor',
  HERO_VIDEO: 'Hero Video',
  VIDEO: 'Video',
  PROJECT_PREVIEW: 'Latest Project Preview',
  PROJECT_HIGHLIGHTS: 'Project Highlights',
  POINT_OF_VIEW: 'PointOfView',
  ADDITIONAL: 'Additional',

  LATEST_CONDO: 'Latest Condo',
  LATEST_HOME: 'Latest Home',
  LATEST_TOWNHOME: 'Latest Townhouse',
  LATEST_NEWS: 'Latest News',
  LATEST_GUIDES: 'Latest Guides',
  LATEST_DECORS: 'Latest Decors',
  LATEST_REVIEW_CONDO: 'Latest Review Condo',
  LATEST_REVIEW_HOME: 'Latest Review Home',
  LATEST_REVIEW_TOWNHOME: 'Latest Review Townhouse',
  LATEST_PREVIEW_CONDO: 'Latest Preview Condo',
  LATEST_PREVIEW_HOME: 'Latest Preview Home',
  LATEST_PREVIEW_TOWNHOME: 'Latest Preview Townhouse',
  LATEST_POV_CONDO: 'Latest POV Condo',
  LATEST_POV_HOME: 'Latest POV Home',
  LATEST_POV_TOWNHOME: 'Latest POV Townhouse',
  LATEST_LOCATION: 'Latest Location',
  LATEST_LOCATION_ZONE: 'Latest Location Zone',
  LATEST_LOCATION_TRAINELINE: 'Latest Location Trainline',
  LATEST_BUY_AND_SELL: 'Latest Buy & Sell',
  LATEST_PROPERTY_NEWS: 'Latest Property News',
  LATEST_INTERIOR_INSPIRATION: 'Latest Interior Inspiration',
  LATEST_RENTAL: 'Latest Rental',
  LATEST_GENERAL_NEWS: 'Latest General News',
  LATEST_RENOVATION: 'Latest Renovation',
  LATEST_FINANCIAL: 'Latest Financial',
  LATEST_INVESTMENT: 'Latest Investment',
  LATEST_MAINTENANCE: 'Latest Maintenance',

  LOCATION_HIGHLIGHT: 'LocationHighlight',
  LOCATION_ZONE_HIGHLIGHT: 'LocationZoneHighlight',
  LOCATION_TRAINELINE_HIGHLIGHT: 'LocationTrainlineHighlight',

  AUTO_SUGGEST: 'AutoSuggest',
  RECOMMENDED: 'Recommended',
  IN_PAGE_SEARCH: 'InPageSearch',

  DD_LISTINGS_DEVELOPER: 'DDListings-Developer',
  DD_LISTINGS_AGENT: 'DDListings-Agent',
};
